import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Overlay, Image } from '@thd-olt-component-react/core-ui';
import { cardImageUrl, analyticsSelectAccount } from '../plccUtils';
import { modalClickEvent, modalImpressionEvent } from '../publisher';
import './account-selector-modal.style.scss';

const AccountSelectorModal = ({ closeModal, linkAccounts, isMobile }) => {
  const [selectedCard, setSelectedCard] = useState('PLCN_HOMEDEPOT');

  useEffect(() => {
    modalImpressionEvent('homepage>select account to link');
  }, []);

  const linkAccountClickHandler = () => {
    modalClickEvent(analyticsSelectAccount[selectedCard]);
    linkAccounts('', selectedCard);
  };

  const switchCard = (event) => {
    setSelectedCard(event.currentTarget.id);
  };

  const getCardClassName = (cardType) => {
    if (selectedCard === cardType) {
      return 'card-container card-enabled card-selected';
    }
    return 'card-container card-enabled card-unselected';
  };

  const getTermsAndConditions = () => {
    let cardType = 'Home Depot Consumer Credit Card account';
    if (selectedCard === 'PLNP_HOMEDEPOT') {
      cardType = 'Commercial Account';
    } else if (selectedCard === 'PLCR_HOMEDEPOT') {
      cardType = 'Commercial Revolving Charge account';
    }
    return (
      <p className="legal-text u__legal u--paddingTop">
        By clicking “Link This Account”, I acknowledge that I am linking my “My
        Account” login and password to my {cardType}. I understand this will
        allow anyone that has access to my “My Account” account information on
        homedepot.com complete access to my {cardType}. I understand that at any
        time, I can unlink these accounts by changing my settings in my “My
        Account” Account Profile on homedepot.com.
      </p>
    );
  };

  return (
    <Overlay
      closeButton
      isMobile={isMobile}
      open
      onClose={closeModal}
      header="Select Card to Link"
      fit
      modalClass="modal-width"
    >
      <div className="account-selector-modal">
        <div className="u__flex modal-center">
          <div
            className={getCardClassName('PLCN_HOMEDEPOT')}
            role="button"
            tabIndex={0}
            id="PLCN_HOMEDEPOT"
            onClick={switchCard}
            onKeyDown={switchCard}
          >
            <Image
              src={cardImageUrl.PLCN_HOMEDEPOT}
              alt="Apply for Home Depot Card"
              title="Apply for Home Depot Card"
              className="modal-image"
              width="115"
              height="73"
            />
            <h3 className="u__bold u__medium u--paddingBottom">
              Home Depot
              <br />
              Consumer Card
            </h3>
            <p className="u--paddingTop u--paddingBottom">No Cards Linked</p>
          </div>
          <div
            className={
              getCardClassName('PLNP_HOMEDEPOT') + ' card-container-margin'
            }
            role="button"
            tabIndex={0}
            id="PLNP_HOMEDEPOT"
            onClick={switchCard}
            onKeyDown={switchCard}
          >
            <Image
              src={cardImageUrl.PLNP_HOMEDEPOT}
              alt="Apply for Home Depot Card"
              title="Apply for Home Depot Card"
              className="modal-image"
              width="115"
              height="73"
            />
            <h3 className="u__bold u__medium u--paddingBottom">
              Commercial
              <br />
              Account
            </h3>
            <p className="u--paddingTop u--paddingBottom">No Cards Linked</p>
          </div>
          <div
            className={getCardClassName('PLCR_HOMEDEPOT')}
            role="button"
            tabIndex={0}
            id="PLCR_HOMEDEPOT"
            onClick={switchCard}
            onKeyDown={switchCard}
          >
            <Image
              src={cardImageUrl.PLCR_HOMEDEPOT}
              alt="Apply for Home Depot Card"
              title="Apply for Home Depot Card"
              className="modal-image"
              width="115"
              height="73"
            />
            <h3 className="u__bold u__medium u--paddingBottom">
              Commercial
              <br />
              Revolving Charge
            </h3>
            <p className="u--paddingTop u--paddingBottom">No Cards Linked</p>
          </div>
        </div>
        <p className="legal-text u__legal u__bold">Terms And Conditions</p>
        {getTermsAndConditions()}
        <div className="u--padding u__border--top modal-bottom">
          <Button onClick={closeModal} outline className="modal-button">
            Cancel
          </Button>
          <Button
            onClick={linkAccountClickHandler}
            className="modal-button"
          >
            Link This Account
          </Button>
        </div>
      </div>
    </Overlay>
  );
};

AccountSelectorModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  linkAccounts: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default AccountSelectorModal;
